import React from "react"
import ReactDOM from "react-dom"
import AreaCardsContainer from "./area-cards-container-component"

export default class AreaCardsContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<AreaCardsContainer {...self.modelJson} />, self.elem)
  }
}
